// Hardcoded city data for the Economic Impact Simulator
// This eliminates API dependency and ensures mobile compatibility

export type CityData = {
  id: number;
  name: string;
  state: string;
  population: number;
  annualReleases: number;
  baselineRecidivismRate: number;
  averageCostPerIncarceration: number;
  currentEmploymentRate: number;
  medianIncome: number;
};

export const CITY_DATA: CityData[] = [
  {
    id: 1,
    name: "Atlanta",
    state: "Georgia",
    population: 498715,
    annualReleases: 8234,
    baselineRecidivismRate: 0.68,
    averageCostPerIncarceration: 31000,
    currentEmploymentRate: 0.62,
    medianIncome: 65381
  },
  {
    id: 2,
    name: "Phoenix",
    state: "Arizona", 
    population: 1608139,
    annualReleases: 12456,
    baselineRecidivismRate: 0.71,
    averageCostPerIncarceration: 28500,
    currentEmploymentRate: 0.59,
    medianIncome: 62055
  },
  {
    id: 3,
    name: "Detroit",
    state: "Michigan",
    population: 670031,
    annualReleases: 15234,
    baselineRecidivismRate: 0.74,
    averageCostPerIncarceration: 35000,
    currentEmploymentRate: 0.52,
    medianIncome: 34762
  },
  {
    id: 4,
    name: "Houston",
    state: "Texas",
    population: 2320268,
    annualReleases: 18745,
    baselineRecidivismRate: 0.69,
    averageCostPerIncarceration: 29800,
    currentEmploymentRate: 0.64,
    medianIncome: 58043
  },
  {
    id: 5,
    name: "Chicago",
    state: "Illinois",
    population: 2693976,
    annualReleases: 21567,
    baselineRecidivismRate: 0.72,
    averageCostPerIncarceration: 38200,
    currentEmploymentRate: 0.58,
    medianIncome: 65781
  },
  {
    id: 6,
    name: "Philadelphia",
    state: "Pennsylvania",
    population: 1584064,
    annualReleases: 14328,
    baselineRecidivismRate: 0.67,
    averageCostPerIncarceration: 42500,
    currentEmploymentRate: 0.61,
    medianIncome: 52649
  },
  {
    id: 7,
    name: "San Antonio",
    state: "Texas",
    population: 1547253,
    annualReleases: 9876,
    baselineRecidivismRate: 0.65,
    averageCostPerIncarceration: 27300,
    currentEmploymentRate: 0.66,
    medianIncome: 56783
  },
  {
    id: 8,
    name: "Memphis",
    state: "Tennessee",
    population: 651073,
    annualReleases: 11245,
    baselineRecidivismRate: 0.73,
    averageCostPerIncarceration: 32100,
    currentEmploymentRate: 0.55,
    medianIncome: 45918
  }
];

export const getCityById = (id: number): CityData | undefined => {
  return CITY_DATA.find(city => city.id === id);
};

export const getAllCities = (): CityData[] => {
  return CITY_DATA;
};